import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { auth } from '@/lib/api';
import { ArrowRight, ShieldCheck } from '@phosphor-icons/react';

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await auth.login(form.email, form.password);
      localStorage.setItem('swift_admin_token', res.token);
      localStorage.setItem('swift_admin_email', res.email);
      toast.success('Welcome back.');
      nav('/admin');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid credentials.');
    } finally { setBusy(false); }
  };

  return (
    <section className="min-h-[80vh] flex items-center py-16" data-testid="admin-login">
      <div className="container-x max-w-md w-full">
        <div className="text-center mb-10">
          <div className="w-14 h-14 rounded-2xl bg-brand flex items-center justify-center mx-auto mb-6">
            <ShieldCheck size={28} weight="fill" className="text-white" />
          </div>
          <div className="overline mb-4 justify-center">Staff login</div>
          <h1 className="font-display font-bold text-3xl text-ink">Inclusive Mobility Admin</h1>
          <p className="body-md mt-2">Only authorised staff. All access is logged.</p>
        </div>
        <form onSubmit={submit} className="p-8 rounded-3xl bg-white border border-neutral-200 shadow-[0_20px_60px_rgba(17,24,39,0.06)] space-y-5" data-testid="admin-login-form">
          <div>
            <label className="label-base">Email</label>
            <input required type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} data-testid="admin-login-email" className="input-base" placeholder="admin@swiftcommunitytransport.com.au" />
          </div>
          <div>
            <label className="label-base">Password</label>
            <input required type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} data-testid="admin-login-password" className="input-base" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="btn-primary w-full">
            {busy ? 'Signing in…' : 'Sign in'} <ArrowRight size={16} weight="bold" />
          </button>
          <div className="text-center text-sm">
            <Link to="/" className="text-ink-muted hover:text-brand">← Back to site</Link>
          </div>
        </form>
      </div>
    </section>
  );
}
